<span [ngStyle]="getStyle()"
      style="
      border: 1px solid !important;
      border-radius:4px;
      padding:2px 4px;
      margin: 2px 2px;
      font-size: 12px;
      display: inline-block;
">{{text|translate}}</span>
